import Pusher from 'pusher-js';
import { DEVELOPMENT } from 'src/constants/environment';
import SITE_SETTINGS from 'src/constants/whiteLabel';
import {
    printByColor,
    RED_COLOR,
    GREEN_COLOR,
    BLUE_COLOR,
} from 'src/utils/logs';

const pusherKey = process.env.REACT_APP_PUSHER_KEY;
let isPusherEnabled = Boolean(pusherKey);
let pusherSubscription = null;
let hasWarnedPusherDisabled = false;
const shouldLogPusher = process.env.REACT_APP_NODE_ENV === DEVELOPMENT;

const warnPusherDisabled = (message, error) => {
    if (hasWarnedPusherDisabled) return;

    hasWarnedPusherDisabled = true;

    if (error) {
        console.warn(message, error);
        return;
    }

    console.warn(message);
};

if (!isPusherEnabled) {
    warnPusherDisabled(
        '[Pusher] REACT_APP_PUSHER_KEY missing, Pusher disabled'
    );
} else {
    try {
        const pusher = new Pusher(pusherKey, {
            cluster: 'us2',
        });

        pusherSubscription = pusher.subscribe(
            `${SITE_SETTINGS.client}_channels`
        );
    } catch (error) {
        isPusherEnabled = false;
        warnPusherDisabled(
            '[Pusher] Failed to initialize Pusher, service disabled',
            error
        );
    }
}

class Channel {
    constructor() {
        this.callbacks = {};
        this.boundEvents = {};
    }

    bind(eventName, callback) {
        if (!isPusherEnabled || !pusherSubscription) return;

        if (!this.boundEvents[eventName]) {
            this.boundEvents[eventName] = true;

            if (!this.callbacks[eventName]) {
                this.callbacks[eventName] = [];
            }
            if (shouldLogPusher)
                printByColor({
                    message: `Bind: ${eventName}`,
                    color: GREEN_COLOR,
                });

            pusherSubscription.bind(eventName, (data) => {
                if (shouldLogPusher) {
                    printByColor({
                        message: `Callback: ${eventName}`,
                        color: BLUE_COLOR,
                    });
                }
                callback(data);
            });
        } else {
            if (shouldLogPusher)
                printByColor({
                    message: `Event ${eventName} is already bound`,
                    color: RED_COLOR,
                });
        }
    }

    unbind(eventName) {
        if (!isPusherEnabled || !pusherSubscription) return;

        if (shouldLogPusher)
            printByColor({ message: `Unbind: ${eventName}`, color: RED_COLOR });

        pusherSubscription.unbind(eventName);
        delete this.boundEvents[eventName];
    }

    unbindAll() {
        if (!isPusherEnabled || !pusherSubscription) return;

        if (shouldLogPusher)
            printByColor({
                message: `Unbinded All subscriptions`,
                color: RED_COLOR,
            });

        pusherSubscription.unbind_all();
        this.boundEvents = {};
    }
}

export const channel = new Channel();
